import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslocoService } from '@ngneat/transloco';
import { BaseDetail } from 'projects/admin/src/app/classes/base-detail';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { HelperService } from 'projects/admin/src/app/services/helper.service';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { DetailModes } from 'projects/admin/src/app/shared/constants';
import { PartnerModel } from 'projects/core/src/lib/models/partner.model';

@Component({
  selector: 'app-partner-detail',
  templateUrl: './partner-detail.component.html',
  styleUrls: ['./partner-detail.component.scss']
})
export class PartnerDetailComponent extends BaseDetail implements OnInit {

  public partner: PartnerModel = null;
  public backRoute = ['/partners'];

  constructor(
    protected ui: UiService,
    protected router: Router,
    protected helper: HelperService,
    protected transloco: TranslocoService,
    private api: ApiService,
    private route: ActivatedRoute,
  ) {
    super(ui, router, helper, transloco);
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      if (params.id > 0) {
        this.setLoading();
        this.api.getModel('partners', params.id).subscribe({
          next: (result: any) => {
            this.partner = new PartnerModel().deserialize(result.data);
            this.setInitialized(DetailModes.edit);
          },
          error: (error: any) => {
            this.setFailed(error);
          }
        });
      } else {
        this.onClose();
      }
    });
  }

}
